
import { initI18n, createSwitcher, getLang, t, applyTranslations, PROJECT_DESC_EN } from "./i18n.js";

// ── Init i18n (before anything renders) ──────────────────────
initI18n();
["lang-switcher-nav", "lang-switcher-footer"].forEach((id) => {
  const el = document.getElementById(id);
  if (el) el.appendChild(createSwitcher());
});
// Re-render panel description when lang changes
document.addEventListener("langchange", () => {
  applyTranslations();
  // Update project count string
  const countEl = document.getElementById("project-count");
  if (countEl && countEl.dataset.total) {
    const total = parseInt(countEl.dataset.total, 10);
    countEl.textContent = `— ${total} ${t(total > 1 ? "pg.count.plural" : "pg.count.singular")}`;
  }
  // Re-render open panel if any
  const panel = document.getElementById("project-panel");
  if (panel && panel.classList.contains("open") && window.__openedProject) {
    const descEl = document.getElementById("panel-description");
    if (descEl) {
      const proj = window.__openedProject;
      const desc = getLang() === "en" && PROJECT_DESC_EN[proj.name]
        ? PROJECT_DESC_EN[proj.name]
        : proj.description;
      descEl.textContent = desc || t("panel.fallback");
    }
  }
});

// ═══════════════════════════════════════════════════════════════
// ██  PROJETS  ██  Ajoute tes projets ici, un bloc par projet
// ═══════════════════════════════════════════════════════════════
//
// Chaque projet a :
//   thumb        → image/vidéo principale affichée dans la grille
//   thumbType    → "image" ou "video"
//   category     → "web" | "video" | "photo"  (utilisé par le filtre)
//   name         → nom affiché au survol et dans le panneau
//   skills       → liste de compétences affichées dans le panneau
//   presentation → phrase d'accroche (panneau)
//   description  → texte long (panneau)
//   gallery      → images/vidéos affichées dans les cellules autour du projet
//                  (entre 1 et 5, type "image" ou "video")
//
// ── Pour ajouter un projet : copie un bloc { ... }, et colle-le
//    à la suite. Change les fichiers et les textes. C'est tout.
// ═══════════════════════════════════════════════════════════════

const PROJECTS = [

  // ── Projet 1 — La Galerie des Souvenirs ──────────────────────
  {
    // Cellule principale dans la grille (image 1 = vidéo)
    thumb: new URL("../img/p1/1.mp4", import.meta.url).href,
    thumbType: "video",
    category: "web",
    name: "La Galerie des Souvenirs",
    year: "2026",
    skills: ["GSAP", "JavaScript", "Figma", "Notion", "Claude AI", "Illustrator", "Photoshop"],
    description: "La Galerie des Souvenirs a été, pour moi, de loin le projet le plus ambitieux que j'ai pu réaliser à l'école. Ce projet est appelé le Projet S6 car il représente le 6ème semestre de la formation. Il s'est déroulé sur plusieurs mois avec un thème commun pour tout le monde : [Hors-Contrôle]. J'ai décidé de partir sur un site représentant un musée interactif afin de raconter l'histoire de l'artiste William Utermohlen et de sa perte de contrôle face à la maladie d'Alzheimer. Mon site retrace toute son histoire, de sa naissance à sa mort, en passant par les différentes périodes de sa vie, jusqu'à l'apparition des premiers symptômes de la maladie. Je suis très fier de ce projet, qui m'a valu la mention excellent lors des rendus. Je prévois aussi de le présenter aux concours Awwwards ou SiteInspire en 2027. Un stand et une affiche ont aussi dû être créés à cette occasion afin de présenter nos travaux à des agences, à des particuliers ainsi qu'aux autres élèves de l'école, lors d'une soirée portes ouvertes spécialement consacrée au projet S6.",
    links: [
      { label: "Voir le site", url: "https://galerie-souvenirs.cordy-maxime.ch/" },
      { label: "Voir sur Figma", url: "https://www.figma.com/design/6hIgtcamjZcU2HR5HYQ2st/Design---Wireframe?node-id=0-1&t=3DjtesAmEmtURarZ-1" },
      { label: "GitHub", url: "https://github.com/MaximeCordy/S6Code" },
    ],
    // hoverMedia = images 2 et 3 affichées dans les cellules autour de la grille
    hoverMedia: [
      { src: new URL("../img/p1/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p1/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p1/4.avif", import.meta.url).href, type: "image" },
    ],
    // gallery = panel slider seulement (images 1→5, images 4 et 5 uniquement ici)
    gallery: [
      { src: new URL("../img/p1/1.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p1/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p1/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p1/4.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p1/5.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 2 — Vitamin Well ───────────────────────────────────
  {
    thumb: new URL("../img/p2/1.mp4", import.meta.url).href,
    thumbType: "video",
    category: "video",
    name: "Vitamin Well",
    year: "2024",
    skills: ["Premiere Pro", "After Effects", "FX-30", "Drone"],
    description: "Cette vidéo est un projet qui me tient à cœur, tant pour sa qualité que pour les efforts endurés afin de la créer. Le but de ce projet était de réaliser une publicité fictive pour la marque de boissons vitaminées [Vitamin Well]. L'ambiance ressentie dans cette vidéo nous fait vivre l'effort et la fatigue durant une course, qui nous mène à une hydratation bien méritée. Le tout est présenté dans une atmosphère froide et nuageuse, renforçant la sensation d'effort et de dépassement de soi. Crédits : Andréa Iacoviello, Magnolia Occhipinti, Maxime Cordy",
    links: [
      { label: "Voir sur YouTube", url: "https://youtu.be/_S8RCfiYGuk" },
    ],
    hoverMedia: [
      { src: new URL("../img/p2/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p2/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p2/4.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p2/1.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p2/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p2/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p2/4.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p2/5.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 3 — Ciné Gusto ─────────────────────────────────────
  {
    thumb: new URL("../img/p3/1.mp4", import.meta.url).href,
    thumbType: "video",
    category: "web",
    name: "Ciné Gusto",
    year: "2026",
    skills: ["Figma", "After Effects", "Notion", "Photoshop", "Illustrator"],
    links: [
      { label: "Voir sur Figma", url: "https://www.figma.com/design/EY4Kay3rBma8YhyQzfOs8N/CINEGUSTO?node-id=232-191&t=ZrKe4GnAdMZUzdCn-1" },
    ],
    description: "Ciné Gusto a été mon dernier gros projet de fin de formation. Pour cet examen de TPI, j'ai dû choisir et créer trois supports dans le but de promouvoir un festival mêlant le cinéma, la gastronomie et la transculturalité. J'ai décidé de réaliser une maquette de landing page en one-page, une vidéo de signalétique diffusée sur les différents emplacements physiques du festival, ainsi qu'un logo d'application mettant en avant une plateforme VOD regroupant tous les films et recettes du festival. Après mon analyse marketing, j'ai commencé par créer une direction artistique dans un style minimaliste afin d'aller directement à l'essentiel. Une touche de halftone appliquée aux affiches de films rappelle l'univers du cinéma, tandis que la nourriture, présentée sous forme de packshots aux couleurs saturées, ouvre l'appétit. Le résultat de ce projet a été présenté pendant 30 minutes devant des experts du domaine. J'en suis satisfait, même si j'aurais aimé y consacrer davantage de temps afin de peaufiner certains détails. Crédits : Maxime Cordy",
    hoverMedia: [
      { src: new URL("../img/p3/2.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p3/4.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p3/5.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p3/1.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p3/2.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p3/4.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p3/5.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 4 — SEUL ───────────────────────────────────────────
  {
    thumb: new URL("../img/p4/1.mp4", import.meta.url).href,
    thumbType: "video",
    category: "video",
    name: "SEUL",
    year: "2024",
    skills: ["Premiere Pro", "After Effects", "FX-30"],
    links: [
      { label: "Voir sur YouTube", url: "https://youtu.be/vXne_YaWgCs" },
    ],
    description: "[SEUL] est un court-métrage fictif réalisé de A à Z avec quatre autres camarades de classe et un acteur. Cette fiction, mise en avant au NiFFF (Neuchâtel International Fantastic Film Festival), met en scène un homme vivant dans son chalet, à l'abri de toute présence humaine, perturbé par une présence étrange qui le tourmente. Cette vidéo a été tournée dans mon chalet familial avec du matériel professionnel prêté par mon ancienne école, [eikon]. Une seule journée de tournage a suffi grâce à un storyboard complet et précis. Le montage a ensuite été réparti entre nous quatre, chacun étant responsable d'un domaine spécifique, comme le son, la musique, la colorimétrie, le montage ou encore les effets réalisés sur After Effects.",
    hoverMedia: [
      { src: new URL("../img/p4/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p4/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p4/4.mp4", import.meta.url).href, type: "video" },
    ],
    gallery: [
      { src: new URL("../img/p4/1.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p4/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p4/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p4/4.mp4", import.meta.url).href, type: "video" },
    ],
  },

  // ── Projet 5 — Muay Thaï ──────────────────────────────────────
  {
    thumb: new URL("../img/p5/1.mp4", import.meta.url).href,
    thumbType: "video",
    category: "video",
    name: "Muay Thaï",
    year: "2025",
    skills: ["Premiere Pro", "After Effects", "R8"],
    links: [
      { label: "Voir sur YouTube", url: "https://youtu.be/LN4GW57PCZo" },
    ],
    description: "Mon ami Nico a gentiment accepté que nous tournions un documentaire dans la salle de sport où il s'entraînait au Muay Thaï. Ce documentaire le suit tout au long de son entraînement, en alternant avec une interview face caméra dans laquelle il répond à des questions sur son lien avec ce sport, les raisons pour lesquelles il l'apprécie, et invite les gens à le découvrir et à le pratiquer. Crédits : Magnolia Occhipinti, Maxime Cordy, Nicola Cleusix",
    hoverMedia: [
      { src: new URL("../img/p5/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p5/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p5/4.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p5/1.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p5/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p5/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p5/4.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 6 — Sabre ──────────────────────────────────────────
  {
    thumb: new URL("../img/p6/1.mp4", import.meta.url).href,
    thumbType: "video",
    category: "web",
    name: "Sabre",
    year: "2025",
    skills: ["GSAP", "JavaScript", "Figma", "Illustrator", "Photoshop"],
    links: [
      { label: "Voir le site", url: "https://maxime-cordy.at-eikon.ch/sabre/" },
      { label: "GitHub", url: "https://github.com/MaximeCordy/storytelling_sabre" },
    ],
    description: "Sabre est un roman graphique écrit par Éric Feres qui suit l'histoire d'un petit tigre pas comme les autres. Le mandat fictif reçu par Eikon nous demandait de créer un site de storytelling afin de promouvoir le livre Sabre. À l'aide de deux de mes collègues, nous avons réimaginé cette histoire pour transmettre des informations et des émotions aux personnes découvrant ce site, mettant ainsi en avant cette œuvre. Le tout après beaucoup de réflexion, de lecture et de code ! Crédits : Andréa Iacoviello, Tilio Pezzoli, Maxime Cordy",
    hoverMedia: [
      { src: new URL("../img/p6/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p6/3.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p6/1.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p6/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p6/3.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 7 — Harlem ─────────────────────────────────────────
  {
    thumb: new URL("../img/p7/1.avif", import.meta.url).href,
    thumbType: "image",
    category: "web",
    name: "Harlem",
    year: "2026",
    skills: ["Figma", "Claude Code"],
    links: [
      { label: "Voir le site", url: "https://harlem.cordy-maxime.ch/" },
      { label: "GitHub", url: "https://github.com/MaximeCordy/Harlem-code" },
    ],
    description: "Ce site est une exception parmi les autres. Pour un projet d'histoire de l'art, nous devions créer un support interactif présentant cinq œuvres d'art ayant un lien entre elles. Vu le manque de temps à disposition, j'ai décidé de créer une maquette sur Figma d'une landing page. Par la suite, j'ai décidé d'utiliser Claude Code et Claude (en mode Cowork) pour réaliser un site en scroll infini composé de plusieurs sections explicatives. Crédits : Maxime Cordy",
    hoverMedia: [
      { src: new URL("../img/p7/2.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p7/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p7/4.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p7/1.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p7/2.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p7/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p7/4.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p7/5.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 8 — Affiches ───────────────────────────────────────
  {
    thumb: new URL("../img/p8/1.avif", import.meta.url).href,
    thumbType: "image",
    category: "photo",
    name: "Affiches",
    year: "2023 – 2025",
    skills: ["Illustrator", "Photoshop"],
    description: "Voici trois affiches que j'ai pu réaliser au fil des années. La première fut mon premier mandat professionnel pour le festival fribourgeois Juvenalia. Celui-ci m'a permis d'être à l'écoute des envies de l'organisation et de rester en lien avec elle tout au long du processus de création. Une très bonne expérience. Les deux autres affiches ont été réalisées dans le cadre de mes cours, pour deux projets différents : la première pour le festival Les Georges, également à Fribourg, et la seconde est une affiche informative sur les langues parlées en Suisse. Elle met en avant une photographie réalisée par un camarade et moi-même, représentant un jeune enfant criant les différentes langues à travers des dessins enfantins. Crédits : Maxime Cordy",
    hoverMedia: [
      { src: new URL("../img/p8/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p8/3.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p8/1.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p8/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p8/3.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 11 — Retraite ──────────────────────────────────────
  {
    thumb: new URL("../img/p11/1.avif", import.meta.url).href,
    thumbType: "image",
    category: "photo",
    name: "Retraite",
    year: "2023",
    skills: ["Photographie", "Sony A6700"],
    description: "Pour cette série d'images sur le thème de la retraite, ma grand-mère a gentiment accepté de poser pendant ses activités sportives favorites. L'objectif était de dresser le portrait d'une retraitée active et de montrer qu'une retraite épanouie peut rimer avec dynamisme, mouvement et passion. Crédits : Maxime Cordy, Micheline Nanchen",
    hoverMedia: [
      { src: new URL("../img/p11/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p11/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p11/4.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p11/1.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p11/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p11/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p11/4.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p11/5.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 9 — Jaguar ─────────────────────────────────────────
  {
    thumb: new URL("../img/p9/1.mp4", import.meta.url).href,
    thumbType: "video",
    category: "video",
    name: "Jaguar",
    year: "2023",
    skills: ["Premiere Pro", "R8", "After Effects"],
    links: [
      { label: "Voir sur YouTube", url: "https://youtu.be/Oz0BNxmVqtk" },
    ],
    description: "Cette vidéo fut ma première vidéo à avoir été tournée au sein de l'école. Une pub fictive faisant la promotion de deux Jaguar Type E, évoluant dans différents environnements, se cherchant désespérément sur les routes de Suisse pour finir par se retrouver à la fin. Deux jours de tournage en extérieur avec deux vieilles voitures ont dû être prévus. Une vidéo tournée avec mon père et ma copine. Crédits : Maxime Cordy, Walter Cordy",
    hoverMedia: [
      { src: new URL("../img/p9/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p9/3.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p9/1.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p9/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p9/3.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 12 — Bota Bota ────────────────────────────────────
  {
    thumb: new URL("../img/p12/0.mp4", import.meta.url).href,
    thumbType: "video",
    category: "web",
    name: "Bota Bota",
    year: "2026",
    skills: ["Illustrator", "Figma", "Photoshop"],
    description: "Ce projet de design graphique m'a permis de me plonger dans un rebranding fictif complet du Jardin botanique de Fribourg. L'idée était de reprendre les bases de l'identité existante afin d'en faire une marque plus moderne, dans le but de favoriser la venue des visiteurs. Nous nous sommes d'abord penchés sur la définition d'un style graphique adapté, avant de réaliser les différentes maquettes. Une idée m'est venue en observant la forme du jardin sur Google Maps. Celle-ci était idéale pour créer un logo faisant le lien entre la symbolique de la nature, représentée par les cernes d'un tronc d'arbre, et la conception harmonieuse du Jardin botanique. Ce concept permet ainsi de refléter à la fois l'identité du lieu et son organisation unique. Crédits : Maxime Cordy, Tilio Pezzoli",
    hoverMedia: [
      { src: new URL("../img/p12/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p12/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p12/4.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p12/0.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p12/1.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p12/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p12/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p12/4.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p12/5.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 13 — Is There Anybody Out There? ──────────────────
  {
    thumb: new URL("../img/p13/1.mp4", import.meta.url).href,
    thumbType: "video",
    category: "video",
    name: "Is There Anybody Out There ?",
    year: "2026",
    skills: ["Premiere Pro", "After Effects"],
    links: [
      { label: "Voir sur YouTube", url: "https://youtu.be/MMjPSG9v6eg" },
    ],
    description: "Un clip musical réalisé sur la chanson \"Is There Anybody Out There ?\" de Pink Floyd, issue de l'album \"The Wall\". Le projet met en scène un jeune homme tourmenté, enfermé dans ses pensées, se demandant s'il existe encore une présence autour de lui. En parallèle, des images de nature dépourvues de toute trace de vie humaine illustrent un monde extérieur silencieux, créant une ambiguïté entre la réalité, la perception et la possible folie du personnage. Crédits : Maxime Cordy, Tilio Pezzoli, Andréa Iacoviello",
    hoverMedia: [
      { src: new URL("../img/p13/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p13/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p13/4.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p13/1.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p13/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p13/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p13/4.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 14 — SABRE Animation ──────────────────────────────
  {
    thumb: new URL("../img/p14/1.mp4", import.meta.url).href,
    thumbType: "video",
    category: "video",
    name: "SABRE Animation",
    year: "2025",
    skills: ["Photoshop", "After Effects"],
    links: [
      { label: "Voir sur YouTube", url: "https://youtu.be/Jl3SyMYfy0s" },
    ],
    description: "Cette animation est la suite du projet web \"SABRE\". Elle reprend l'univers graphique du site pour créer une séquence animée immersive, mêlant motion design et identité visuelle forte. Le projet explore les possibilités narratives de l'animation dans le cadre d'une identité de marque. Crédits : Maxime Cordy, Tilio Pezzoli, Andréa Iacoviello",
    hoverMedia: [
      { src: new URL("../img/p14/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p14/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p14/4.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p14/1.mp4", import.meta.url).href, type: "video" },
      { src: new URL("../img/p14/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p14/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p14/4.avif", import.meta.url).href, type: "image" },
    ],
  },

  // ── Projet 10 — Croatie ───────────────────────────────────────
  {
    thumb: new URL("../img/p10/1.avif", import.meta.url).href,
    thumbType: "image",
    category: "photo",
    name: "Croatie",
    year: "2024",
    skills: ["Photographie", "Sony A6700"],
    description: "J'aime la photographie, que ce soit de nature, en studio ou en portrait. Ces clichés viennent tout droit de Croatie, capturés avec mon Sony A6700 sur l'île de Komiža. Le but était de créer une série de photos représentant les vacances à la plage, avec une approche nostalgique. Crédits : Maxime Cordy",
    hoverMedia: [
      { src: new URL("../img/p10/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p10/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p10/4.avif", import.meta.url).href, type: "image" },
    ],
    gallery: [
      { src: new URL("../img/p10/1.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p10/2.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p10/3.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p10/4.avif", import.meta.url).href, type: "image" },
      { src: new URL("../img/p10/5.avif", import.meta.url).href, type: "image" },
    ],
  },

];

// ── Dérivation automatique (ne pas modifier) ──────────────────
const MEDIA = PROJECTS.map((p) => ({
  src: p.thumb,
  type: p.thumbType,
  category: p.category,
  name: p.name,
  year: p.year,
  skills: p.skills,
  presentation: p.presentation,
  description: p.description,
  mediaCaption: p.name,
}));

// Les images de gap sont maintenant gérées projet par projet (hoverMedia ou gallery),
// directement dans makeCell() — plus de pool global HOVER_MEDIA.

// ── Page transition ───────────────────────────────────────────
const PageTransition = (() => {
  const N_BANDS = 4;
  const ENTER_DUR = 500;
  const EXIT_DUR = 550;
  const STAGGER = 60;
  const container = document.getElementById("page-transition");
  let bands = [];
  let rafId = null;

  const easeOutExpo = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));
  const easeInExpo = (t) => (t === 0 ? 0 : Math.pow(2, 10 * t - 10));

  function buildBands(startCovered) {
    container.querySelectorAll(".pt-band").forEach((el) => el.remove());
    bands = [];
    const W = window.innerWidth;
    const bandH = window.innerHeight / N_BANDS;
    for (let i = 0; i < N_BANDS; i++) {
      const el = document.createElement("div");
      el.className = "pt-band";
      el.style.top = `${i * bandH}px`;
      el.style.height = `${bandH + 1}px`;
      if (startCovered) el.style.transform = `translateX(${W + 4}px)`;
      container.appendChild(el);
      bands.push(el);
    }
  }

  // Bands sweep IN → when fully covered → onCovered()
  function enter(onCovered) {
    if (rafId) return;
    buildBands(false);
    container.classList.add("active");

    const W = window.innerWidth;
    const COVERED_AT = ENTER_DUR + (N_BANDS - 1) * STAGGER;
    let called = false;
    const startTs = performance.now();

    function tick(now) {
      const elapsed = now - startTs;

      bands.forEach((el, i) => {
        const s = i * STAGGER;
        let tx =
          elapsed < s
            ? 0
            : elapsed < s + ENTER_DUR
              ? easeOutExpo((elapsed - s) / ENTER_DUR) * (W + 4)
              : W + 4;
        el.style.transform = `translateX(${tx}px)`;
      });

      if (!called && elapsed >= COVERED_AT) {
        called = true;
        rafId = null;
        if (typeof onCovered === "function") onCovered();
        return;
      }

      rafId = requestAnimationFrame(tick);
    }

    rafId = requestAnimationFrame(tick);
  }

  // Bands start covered → sweep OUT
  function exit(onDone) {
    buildBands(true);
    container.classList.add("active");
    document.documentElement.classList.remove("pt-loading");

    const W = window.innerWidth;
    const TOTAL = EXIT_DUR + (N_BANDS - 1) * STAGGER;
    const startTs = performance.now();

    function tick(now) {
      const elapsed = now - startTs;

      bands.forEach((el, i) => {
        const s = i * STAGGER;
        let tx =
          elapsed < s
            ? W + 4
            : elapsed < s + EXIT_DUR
              ? W + 4 + easeInExpo((elapsed - s) / EXIT_DUR) * (W + 4)
              : (W + 4) * 2;
        el.style.transform = `translateX(${tx}px)`;
      });

      if (elapsed < TOTAL) {
        rafId = requestAnimationFrame(tick);
      } else {
        container.classList.remove("active");
        bands.forEach((el) => el.remove());
        bands = [];
        rafId = null;
        if (typeof onDone === "function") onDone();
      }
    }

    rafId = requestAnimationFrame(tick);
  }

  return { enter, exit };
})();

// Wire up all internal links
document.querySelectorAll("a[href]").forEach((link) => {
  const href = link.getAttribute("href");
  if (!href || href.startsWith("#") || href.startsWith("http") || href.startsWith("mailto:") || link.hasAttribute("download") || link.getAttribute("target") === "_blank") return;
  link.addEventListener("click", (e) => {
    e.preventDefault();
    sessionStorage.setItem("pt-active", "1");
    PageTransition.enter(() => {
      window.location.href = href;
    });
  });
});

// ── Letter animation ──────────────────────────────────────────
const letterFlash = document.getElementById("letter-anim-flash");

function animateLetters(
  el,
  { delay = 80, flashDur = 120, squareH = 0.82, squareV = 0.08 } = {},
) {
  // Collect nodes before clearing — preserve <br> elements
  const nodes = Array.from(el.childNodes);
  el.innerHTML = "";
  el.style.display = "flex";
  el.style.flexWrap = "wrap";
  el.style.alignItems = "baseline";

  nodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR") {
      // Preserve line breaks as block-level flex breaks
      const br = document.createElement("span");
      br.style.cssText = "width:100%;height:0;display:block;";
      el.appendChild(br);
    } else {
      const text = node.textContent;
      text.split("").forEach((ch) => {
        const span = document.createElement("span");
        span.className = "letter-anim-char";
        span.textContent = ch === " " ? "\u00A0" : ch;
        el.appendChild(span);
      });
    }
  });

  const letters = Array.from(el.querySelectorAll(".letter-anim-char"));
  let flashTimer = null;

  requestAnimationFrame(() => {
    const widths = letters
      .map((l) => l.getBoundingClientRect().width)
      .filter((w) => w > 4);
    const avgW = widths.length
      ? Math.round(widths.reduce((a, b) => a + b, 0) / widths.length)
      : 40;

    let i = 0;

    function showFlash(letterEl) {
      const rect = letterEl.getBoundingClientRect();
      const h = Math.round(rect.height * squareH);
      const w = avgW;
      const x = rect.left + (rect.width - w) / 2;
      const y = rect.top + rect.height * squareV;
      letterFlash.style.cssText = `width:${w}px;height:${h}px;left:${x}px;top:${y}px;`;
      letterFlash.classList.add("on");
      if (flashTimer) clearTimeout(flashTimer);
      flashTimer = setTimeout(
        () => letterFlash.classList.remove("on"),
        flashDur,
      );
    }

    function step() {
      if (i >= letters.length) return;
      const cur = letters[i];
      cur.classList.add("visible");
      requestAnimationFrame(() => showFlash(cur));
      i++;
      setTimeout(step, delay);
    }

    setTimeout(step, 200);
  });
}

// Exposé globalement pour home-about.js (classic script)
window.animateLetters = animateLetters;

// ── Reveal animation (gallery images) ────────────────────────
let revealReady = false;
const revealPending = [];

const revealObserver = new IntersectionObserver(
  (entries) => {
    if (!revealReady) {
      entries
        .filter((e) => e.isIntersecting)
        .forEach((e) => revealPending.push(e.target));
      return;
    }
    const visible = entries.filter((e) => e.isIntersecting);
    visible
      .sort(
        (a, b) =>
          a.boundingClientRect.top - b.boundingClientRect.top ||
          a.boundingClientRect.left - b.boundingClientRect.left,
      )
      .forEach((entry, i) => {
        entry.target.style.setProperty("--reveal-delay", i * 110 + "ms");
        entry.target.classList.add("visible");
        revealObserver.unobserve(entry.target);
      });
  },
  { threshold: 0.1 },
);

function startReveal() {
  revealReady = true;
  // Flush elements that were already intersecting during the PT
  if (revealPending.length) {
    revealPending
      .sort(
        (a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top,
      )
      .forEach((el, i) => {
        el.style.setProperty("--reveal-delay", i * 110 + "ms");
        el.classList.add("visible");
        revealObserver.unobserve(el);
      });
    revealPending.length = 0;
  }
}

// Déclenchement PT — ici startReveal est déjà définie
const _ptWasActive = !!sessionStorage.getItem("pt-active");
const _openProject = sessionStorage.getItem("open-project");
if (_openProject) sessionStorage.removeItem("open-project");

if (_ptWasActive) {
  sessionStorage.removeItem("pt-active");
  requestAnimationFrame(() => PageTransition.exit(() => {
    startReveal();
    if (_openProject) {
      setTimeout(() => {
        const mediaItem = MEDIA.find(m => m.name === _openProject);
        if (mediaItem) openProjectPanel(mediaItem);
      }, 400);
    }
  }));
} else {
  startReveal();
  if (_openProject) {
    setTimeout(() => {
      const mediaItem = MEDIA.find(m => m.name === _openProject);
      if (mediaItem) openProjectPanel(mediaItem);
    }, 400);
  }
}

let revealCount = 0;

// ── IntersectionObserver : lecture vidéo seulement quand visible ──
const videoPlayObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    const v = entry.target;
    if (entry.isIntersecting) {
      if (v.paused) v.play().catch(() => {});
    } else {
      if (!v.paused) v.pause();
    }
  });
}, { threshold: 0.1 });

function makeMediaEl({ src, type }) {
  let el;
  if (type === "video") {
    el = document.createElement("video");
    el.preload = "none";   // ← ne charge rien tant que non visible
    el.src = src;
    el.muted = true;
    el.loop = true;
    el.playsInline = true;
    videoPlayObserver.observe(el);
  } else {
    el = document.createElement("img");
    el.loading = "lazy";   // ← charge seulement quand l'image approche du viewport
    el.src = src;
  }
  const i = revealCount++;
  const sign = i % 2 === 0 ? -1 : 1;
  el.style.setProperty("--rot-start", sign * (2 + (i % 3)) + "deg");
  el.classList.add("reveal");
  revealObserver.observe(el);
  return el;
}

// ── Nav animations ────────────────────────────────────────────
document.querySelectorAll(".masthead .nav a:not(.nav__logo)").forEach((el) => {
  el.addEventListener("mouseenter", () => animateLetters(el, { delay: 35 }));
});

const filterToggle = document.getElementById("filter-toggle");
const filterMenu = document.getElementById("filters");

if (filterToggle) {
  filterToggle.addEventListener("click", (e) => {
    e.stopPropagation();
    filterMenu.classList.toggle("open");
    if (filterMenu.classList.contains("open")) {
      document.querySelectorAll(".filter-tag").forEach((el, i) => {
        setTimeout(() => animateLetters(el, { delay: 28 }), i * 60);
      });
    }
  });
  document.addEventListener("click", (e) => {
    if (!filterMenu.contains(e.target) && e.target !== filterToggle) {
      filterMenu.classList.remove("open");
    }
  });
}

// ── Titre gallery hover ───────────────────────────────────────
const galleryTitleEl = document.querySelector(".gallery-title");
if (galleryTitleEl) {
  let titleCooldown = false;
  galleryTitleEl.addEventListener("mouseenter", () => {
    if (titleCooldown) return;
    titleCooldown = true;
    animateLetters(galleryTitleEl, { delay: 55, squareH: 0.75 });
    setTimeout(() => {
      titleCooldown = false;
    }, 4000);
  });
}

// ── Panel global ──────────────────────────────────────────────
const panelBackdrop = document.getElementById("panel-backdrop");
const projectPanel = document.getElementById("project-panel");
const panelClose = document.getElementById("panel-close");

// ── Slider ────────────────────────────────────────────────────
let sliderSlides = [];
let sliderIdx = 0;
const sliderTrack = document.getElementById("slider-track");
const sliderDotsEl = document.getElementById("slider-dots");
const sliderPrev = document.getElementById("slider-prev");
const sliderNext = document.getElementById("slider-next");

function renderSlider() {
  sliderTrack.innerHTML = "";
  sliderDotsEl.innerHTML = "";

  sliderSlides.forEach((slide, i) => {
    const div = document.createElement("div");
    div.className = "pp__slide";

    if (slide.type === "placeholder") {
      const ph = document.createElement("div");
      ph.className = "pp__slide-placeholder";
      div.appendChild(ph);
    } else {
      const media =
        slide.type === "video"
          ? Object.assign(document.createElement("video"), {
              src: slide.src,
              autoplay: true,
              muted: true,
              loop: true,
              playsInline: true,
            })
          : Object.assign(document.createElement("img"), {
              src: slide.src,
              alt: "",
            });
      media.className = "pp__slide-media";
      media.addEventListener("click", () => openLightbox(slide.src, slide.type, sliderSlides.filter(s => s.type !== "placeholder")));
      div.appendChild(media);

      if (slide.caption) {
        const cap = document.createElement("p");
        cap.className = "pp__slide-caption";
        cap.textContent = slide.caption;
        div.appendChild(cap);
      }
    }

    sliderTrack.appendChild(div);

    const dot = document.createElement("button");
    dot.className = "pp__slider-dot" + (i === sliderIdx ? " active" : "");
    dot.addEventListener("click", () => goToSlide(i));
    sliderDotsEl.appendChild(dot);
  });

  updateSliderPosition();
}


// ── Lightbox slider ───────────────────────────────────────────
const lightbox = document.createElement("div");
lightbox.className = "pp-lightbox";

const lbPrev = document.createElement("button");
lbPrev.className = "pp-lightbox__nav pp-lightbox__nav--prev";
lbPrev.innerHTML = "&#8592;";
lbPrev.setAttribute("aria-label", "Précédent");

const lbNext = document.createElement("button");
lbNext.className = "pp-lightbox__nav pp-lightbox__nav--next";
lbNext.innerHTML = "&#8594;";
lbNext.setAttribute("aria-label", "Suivant");

const lbClose = document.createElement("button");
lbClose.className = "pp-lightbox__close";
lbClose.innerHTML = "&#215;";
lbClose.setAttribute("aria-label", "Fermer");

const lbCounter = document.createElement("span");
lbCounter.className = "pp-lightbox__counter";

const lbMediaWrap = document.createElement("div");
lbMediaWrap.className = "pp-lightbox__wrap";

lightbox.appendChild(lbPrev);
lightbox.appendChild(lbMediaWrap);
lightbox.appendChild(lbNext);
lightbox.appendChild(lbClose);
lightbox.appendChild(lbCounter);
document.body.appendChild(lightbox);

let lbSlides = [];
let lbIndex = 0;

function lbShowSlide(idx) {
  lbIndex = (idx + lbSlides.length) % lbSlides.length;
  const slide = lbSlides[lbIndex];

  lbMediaWrap.innerHTML = "";
  let el;
  if (slide.type === "video") {
    el = Object.assign(document.createElement("video"), {
      src: slide.src, autoplay: true, muted: true, loop: true, playsInline: true,
    });
  } else {
    el = Object.assign(document.createElement("img"), { src: slide.src, alt: "" });
  }
  el.className = "pp-lightbox__media";
  el.addEventListener("click", (e) => e.stopPropagation());
  lbMediaWrap.appendChild(el);

  lbCounter.textContent = `${lbIndex + 1} / ${lbSlides.length}`;
  lbPrev.style.display = lbSlides.length <= 1 ? "none" : "";
  lbNext.style.display = lbSlides.length <= 1 ? "none" : "";
}

function openLightbox(src, type, slides) {
  lbSlides = slides || [{ src, type }];
  const startIdx = lbSlides.findIndex(s => s.src === src);
  lightbox.classList.add("open");
  lbShowSlide(startIdx >= 0 ? startIdx : 0);
  document.addEventListener("keydown", lbKeyHandler);
}

function closeLightbox() {
  lightbox.classList.remove("open");
  document.removeEventListener("keydown", lbKeyHandler);
  lbMediaWrap.innerHTML = "";
}

function lbKeyHandler(e) {
  if (e.key === "Escape")     closeLightbox();
  if (e.key === "ArrowRight") lbShowSlide(lbIndex + 1);
  if (e.key === "ArrowLeft")  lbShowSlide(lbIndex - 1);
}

lbPrev.addEventListener("click",  (e) => { e.stopPropagation(); lbShowSlide(lbIndex - 1); });
lbNext.addEventListener("click",  (e) => { e.stopPropagation(); lbShowSlide(lbIndex + 1); });
lbClose.addEventListener("click", (e) => { e.stopPropagation(); closeLightbox(); });
lightbox.addEventListener("click", closeLightbox);

// Swipe mobile
let lbTouchX = null;
lightbox.addEventListener("touchstart", (e) => { lbTouchX = e.touches[0].clientX; }, { passive: true });
lightbox.addEventListener("touchend",   (e) => {
  if (lbTouchX === null) return;
  const dx = e.changedTouches[0].clientX - lbTouchX;
  if (Math.abs(dx) > 50) dx < 0 ? lbShowSlide(lbIndex + 1) : lbShowSlide(lbIndex - 1);
  lbTouchX = null;
});

function updateSliderPosition() {
  const slide = sliderTrack.querySelectorAll(".pp__slide")[sliderIdx];
  if (slide) {
    sliderTrack.scrollTo({
      left: slide.offsetLeft - sliderTrack.offsetLeft,
      behavior: "smooth",
    });
  }
  document.querySelectorAll(".pp__slider-dot").forEach((dot, i) => {
    dot.classList.toggle("active", i === sliderIdx);
  });
  sliderPrev.disabled = sliderIdx === 0;
  sliderNext.disabled = sliderIdx === sliderSlides.length - 1;
}

function goToSlide(idx) {
  sliderIdx = Math.max(0, Math.min(idx, sliderSlides.length - 1));
  updateSliderPosition();
}

sliderPrev.addEventListener("click", () => goToSlide(sliderIdx - 1));
sliderNext.addEventListener("click", () => goToSlide(sliderIdx + 1));

function openProjectPanel(mediaItem) {
  document.getElementById("panel-cat-label").textContent = mediaItem.category;

  const titleEl = document.getElementById("panel-title");
  titleEl.textContent = mediaItem.name;
  document.getElementById("panel-cat-val").textContent = mediaItem.category;
  document.getElementById("panel-year").textContent = mediaItem.year || "—";

  const skillsEl = document.getElementById("panel-skills");
  skillsEl.innerHTML = "";
  (mediaItem.skills || []).forEach((s) => {
    const pill = document.createElement("span");
    pill.className = "pp-skill";
    pill.textContent = s;
    skillsEl.appendChild(pill);
  });

  // Description : use EN version if lang=en and available
  const project = PROJECTS.find(p => p.name === mediaItem.name);
  window.__openedProject = project || null;
  const desc = getLang() === "en" && project && PROJECT_DESC_EN[project.name]
    ? PROJECT_DESC_EN[project.name]
    : (mediaItem.description || mediaItem.presentation || t("panel.fallback"));
  document.getElementById("panel-description").textContent = desc;

  // Galerie : utilise les vrais médias du projet si disponibles
  if (project && project.gallery && project.gallery.length) {
    sliderSlides = project.gallery.map(g => ({ src: g.src, type: g.type, caption: "" }));
  } else {
    sliderSlides = [{ src: mediaItem.src, type: mediaItem.type, caption: "" }];
  }
  sliderIdx = 0;
  renderSlider();

  // Liens
  const textsEl = projectPanel.querySelector(".pp__texts");
  const existingLinks = projectPanel.querySelector(".pp__links");
  if (existingLinks) existingLinks.remove();
  if (project && project.links && project.links.length) {
    const linksDiv = document.createElement("div");
    linksDiv.className = "pp__links";
    project.links.forEach(link => {
      const a = document.createElement("a");
      a.href = link.url;
      a.target = "_blank";
      a.rel = "noopener";
      a.className = "pp__link";
      // Translate the link label
      const labelMap = { "Voir le site": "link.website", "Voir sur Figma": "link.figma", "Voir sur YouTube": "link.youtube", "GitHub": "link.github" };
      a.textContent = (labelMap[link.label] ? t(labelMap[link.label]) : link.label) + " ↗";
      linksDiv.appendChild(a);
    });
    textsEl.appendChild(linksDiv);
  }

  projectPanel.querySelector(".pp__scroll").scrollTop = 0;
  panelBackdrop.classList.add("open");
  projectPanel.classList.add("open");
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.width = "100%";
  panelClose.focus();

  setTimeout(() => {
    animateLetters(titleEl, { delay: 55 });
    projectPanel.querySelectorAll(".pp__label").forEach((el, i) => {
      setTimeout(() => animateLetters(el, { delay: 25 }), 100 + i * 70);
    });
  }, 200);
}

let currentOpenClose = null;

function closeProjectPanel() {
  panelBackdrop.classList.remove("open");
  projectPanel.classList.remove("open");
  projectPanel.classList.remove("expanded");
  document.body.style.overflow = "";
  document.body.style.position = "";
  document.body.style.width = "";
  if (currentOpenClose) {
    currentOpenClose = null;
  }
}

// ── Expansion 100% au scroll ───────────────────────────────────
const ppScroll = projectPanel.querySelector(".pp__scroll");
ppScroll.addEventListener("scroll", () => {
  if (ppScroll.scrollTop > 40) {
    projectPanel.classList.add("expanded");
  } else {
    projectPanel.classList.remove("expanded");
  }
}, { passive: true });

panelClose.addEventListener("click", closeProjectPanel);
panelBackdrop.addEventListener("click", closeProjectPanel);
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && projectPanel.classList.contains("open"))
    closeProjectPanel();
});

// ── Swipe vers le bas pour fermer le panel (mobile) ───────────
(function () {
  const ppBar = projectPanel.querySelector(".pp__bar");
  if (!ppBar) return;

  let touchStartY = 0;
  let dragging = false;

  ppBar.addEventListener("touchstart", (e) => {
    touchStartY = e.touches[0].clientY;
    dragging = false;
  }, { passive: true });

  ppBar.addEventListener("touchmove", (e) => {
    const dy = e.touches[0].clientY - touchStartY;
    if (dy > 0) {
      if (!dragging) {
        dragging = true;
        projectPanel.style.transition = "none";
      }
      const clamped = Math.min(dy, 320);
      projectPanel.style.transform = `translateY(${clamped * 0.6}px)`;
      projectPanel.style.opacity = `${1 - (clamped / 320) * 0.5}`;
    }
  }, { passive: true });

  ppBar.addEventListener("touchend", (e) => {
    const dy = e.changedTouches[0].clientY - touchStartY;
    projectPanel.style.transition = "";
    projectPanel.style.transform = "";
    projectPanel.style.opacity = "";
    if (dragging && dy > 80) {
      if (currentOpenClose) currentOpenClose();
      else closeProjectPanel();
    }
    dragging = false;
  }, { passive: true });
})();

// ── Galerie ───────────────────────────────────────────────────
const gallery = document.getElementById("gallery");

if (gallery) {
  const GAP_PATTERN = [3, 2, 3, 2, 3, 2];
  let gapPatternIdx = 0;
  function getGap() {
    return GAP_PATTERN[gapPatternIdx++ % GAP_PATTERN.length];
  }

  function getCols() {
    return window.innerWidth <= 768 ? 3 : 6;
  }
  let COLS = getCols();
  let bottomRow = null;

  let cellCount = 0;
  let mediaIdx = 0;
  let nextMediaAt = 0;
  let gapEnd = 0;
  let currentFullGroup = null;
  let currentBorderGroup = null;
  let currentProjectHoverMedia = [];
  let currentProjectHoverIdx = 0;

  // Média actifs (tous par défaut, filtrés sur demande)
  let activeMedia = MEDIA;
  let activeProjects = PROJECTS;

  function makeCell() {
    const cell = document.createElement("div");
    cell.className = "cell";

    const c1 = document.createElement("div");
    c1.className = "cross";
    c1.style.cssText = "top:0; left:0;";
    cell.appendChild(c1);

    const isMedia = mediaIdx < activeMedia.length && cellCount === nextMediaAt;
    const isGap = !isMedia && currentBorderGroup !== null && cellCount < gapEnd;
    const isHover = isGap && currentProjectHoverIdx < currentProjectHoverMedia.length;

    if (isMedia) {
      cell.classList.add("cell--media");
      cell.dataset.category = activeMedia[mediaIdx].category;
      cell.appendChild(makeMediaEl(activeMedia[mediaIdx]));

      const fullGroup = [cell];
      cell._groupCells = fullGroup;
      const borderGroup = [];
      currentFullGroup = fullGroup;
      currentBorderGroup = borderGroup;
      // Hover images = uniquement celles de ce projet
      const proj = PROJECTS.find((p) => p.name === activeMedia[mediaIdx].name);
      currentProjectHoverMedia = proj ? (proj.hoverMedia !== undefined ? proj.hoverMedia : proj.gallery) : [];
      currentProjectHoverIdx = 0;
      const gap = getGap();
      gapEnd = cellCount + 1 + gap;
      nextMediaAt = gapEnd;

      const mediaItem = activeMedia[mediaIdx];
      const itemName = mediaItem.name;
      let rect = null;

      cell.addEventListener("click", () => {
        if (currentOpenClose) {
          currentOpenClose();
          currentOpenClose = null;
        }
        openProjectPanel(mediaItem);
        cell._groupCells.forEach((c) => c.classList.add("is-selected"));
        currentOpenClose = () => {
          closeProjectPanel();
          cell._groupCells.forEach((c) => c.classList.remove("is-selected"));
        };
      });

      const showRect = () => {
        if (rect) return;
        cell.classList.add("is-source");
        if (borderGroup.length > 0) {
          const galleryRect = gallery.getBoundingClientRect();
          const allCells = [cell, ...borderGroup];
          const rows = new Map();
          allCells.forEach((c) => {
            const r = c.getBoundingClientRect();
            const rowKey = Math.round(r.top);
            if (!rows.has(rowKey)) rows.set(rowKey, []);
            rows.get(rowKey).push(r);
          });
          const rects = [];
          rows.forEach((cellRects) => {
            const minX = Math.min(...cellRects.map((r) => r.left));
            const minY = Math.min(...cellRects.map((r) => r.top));
            const maxX = Math.max(...cellRects.map((r) => r.right));
            const maxY = Math.max(...cellRects.map((r) => r.bottom));
            const el = document.createElement("div");
            el.className = "gap-rect";
            el.style.cssText = `left:${minX - galleryRect.left}px;top:${minY - galleryRect.top}px;width:${maxX - minX}px;height:${maxY - minY}px;`;
            rects.push(el);
            gallery.appendChild(el);
          });
          hoverLabel.textContent = itemName;
          hoverLabel.classList.add("is-visible");
          rect = rects;
        }
      };

      const hideRect = () => {
        cell.classList.remove("is-source");
        hoverLabel.classList.remove("is-visible");
        if (rect) {
          const dying = rect;
          rect = null;
          dying.forEach((el) => {
            el.classList.add("is-out");
            el.addEventListener("transitionend", () => el.remove(), {
              once: true,
            });
          });
        }
      };

      cell.addEventListener("mouseenter", showRect);
      cell.addEventListener("mouseleave", hideRect);

      mediaIdx++;
    } else if (isGap) {
      currentBorderGroup.push(cell);
      currentFullGroup.push(cell);

      const sourceCell = currentFullGroup[0];
      cell.addEventListener("mouseenter", () =>
        sourceCell.dispatchEvent(new MouseEvent("mouseenter")),
      );
      cell.addEventListener("mouseleave", () =>
        sourceCell.dispatchEvent(new MouseEvent("mouseleave")),
      );
      cell.addEventListener("click", () =>
        sourceCell.dispatchEvent(new MouseEvent("click")),
      );

      if (isHover) {
        cell.classList.add("cell--hover");
        cell.appendChild(makeMediaEl(currentProjectHoverMedia[currentProjectHoverIdx]));
        currentProjectHoverIdx++;
      } else {
        cell.classList.add("cell--gap");
      }
    }

    cellCount++;
    return cell;
  }

  function makeBottomRow() {
    const row = document.createElement("div");
    row.className = "row";
    row.style.height = "0";
    for (let c = 0; c < COLS; c++) {
      const cell = document.createElement("div");
      cell.style.cssText = "position:relative; height:0; overflow:visible;";
      const cross = document.createElement("div");
      cross.className = "cross";
      cross.style.cssText = "top:0; left:0;";
      cell.appendChild(cross);
      if (c === COLS - 1) {
        const crossR = document.createElement("div");
        crossR.className = "cross";
        crossR.style.cssText =
          "top:0; right:0; left:auto; transform:translate(50%,-50%);";
        cell.appendChild(crossR);
      }
      row.appendChild(cell);
    }
    return row;
  }

  function addRows(count) {
    if (bottomRow) bottomRow.remove();
    for (let r = 0; r < count; r++) {
      const row = document.createElement("div");
      row.className = "row";
      for (let c = 0; c < COLS; c++) {
        const cell = makeCell();
        if (c === COLS - 1) {
          const cr = document.createElement("div");
          cr.className = "cross";
          cr.style.cssText =
            "top:0; right:0; left:auto; transform:translate(50%,-50%);";
          cell.appendChild(cr);
        }
        row.appendChild(cell);
      }
      gallery.appendChild(row);
    }
    bottomRow = makeBottomRow();
    gallery.appendChild(bottomRow);
  }

  // Calcul dynamique : juste assez de rangées pour tous les projets + leurs gaps
  const GAP_PATTERN_CALC = [3, 2, 3, 2, 3, 2];

  function resetGalleryState() {
    gallery.innerHTML = "";
    bottomRow = null;
    cellCount = 0;
    mediaIdx = 0;
    nextMediaAt = 0;
    gapEnd = 0;
    currentFullGroup = null;
    currentBorderGroup = null;
    gapPatternIdx = 0;
    revealCount = 0;
  }

  function rebuildGallery(cat) {
    activeMedia    = cat === "all" ? MEDIA    : MEDIA.filter(m => m.category === cat);
    activeProjects = cat === "all" ? PROJECTS : PROJECTS.filter(p => p.category === cat);
    resetGalleryState();
    const total = activeProjects.reduce((sum, _, i) => sum + 1 + GAP_PATTERN_CALC[i % GAP_PATTERN_CALC.length], 0);
    addRows(Math.ceil(total / COLS));
  }

  const totalCells = PROJECTS.reduce((sum, _, i) => sum + 1 + GAP_PATTERN_CALC[i % GAP_PATTERN_CALC.length], 0);
  const rowsNeeded = Math.ceil(totalCells / COLS);
  addRows(rowsNeeded);

  // ── Compteur projets ────────────────────────────────────────
  const projectCountEl = document.getElementById("project-count");

  function updateCount(cat) {
    if (!projectCountEl) return;
    const total = cat === "all"
      ? MEDIA.length
      : MEDIA.filter((m) => m.category === cat).length;
    projectCountEl.dataset.total = total;
    projectCountEl.textContent = `— ${total} ${t(total > 1 ? "pg.count.plural" : "pg.count.singular")}`;
  }

  updateCount("all");

  // ── Filtres ─────────────────────────────────────────────────
  const filterTags = document.querySelectorAll(".filter-tag");
  filterTags.forEach((btn) => {
    btn.addEventListener("click", () => {
      filterTags.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      const cat = btn.dataset.filter;
      rebuildGallery(cat);
      updateCount(cat);
    });
  });

  window.addEventListener("resize", () => {
    const newCols = getCols();
    if (newCols !== COLS) {
      COLS = newCols;
      resetGalleryState();
      const _totalCells = activeProjects.reduce((sum, _, i) => sum + 1 + GAP_PATTERN_CALC[i % GAP_PATTERN_CALC.length], 0);
      addRows(Math.ceil(_totalCells / COLS));
    }
  });
}

// ── Barre de progression latérale ────────────────────────────
(function () {
  const fill = document.getElementById("nav-fill");
  const dot  = document.getElementById("nav-dot");
  if (!fill || !dot) return;
  function update() {
    const p = Math.min(1, window.scrollY / (document.body.scrollHeight - window.innerHeight || 1));
    fill.style.height = p * 100 + "%";
    dot.style.top     = p * 100 + "%";
  }
  window.addEventListener("scroll", update, { passive: true });
  update();
})();

// ── Animations chargement home ────────────────────────────────
const brandTextEl = document.getElementById("brand-text");
if (brandTextEl)
  setTimeout(() => animateLetters(brandTextEl, { delay: 45 }), 100);

document
  .querySelectorAll(".masthead .nav a:not(.nav__logo)")
  .forEach((el, i) => {
    setTimeout(() => animateLetters(el, { delay: 35 }), 200 + i * 120);
  });

document.querySelectorAll(".hero-line").forEach((el, i) => {
  setTimeout(() => animateLetters(el, { delay: 15 }), 400 + i * 200);
});

const taglineEl = document.querySelector(".home-hero__tagline");
if (taglineEl) {
  taglineEl.style.opacity = "0";
  taglineEl.style.transform = "translateY(16px)";
  taglineEl.style.transition =
    "opacity 1.1s cubic-bezier(0.22,1,0.36,1) 0.3s, transform 1.2s cubic-bezier(0.22,1,0.36,1) 0.3s";
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      taglineEl.style.opacity = "1";
      taglineEl.style.transform = "translateY(0)";
    }),
  );
}

// ── Hero ──────────────────────────────────────────────────────
const masthead = document.querySelector(".masthead");
const homeHeroEl = document.querySelector(".home-hero");

// ── (GSAP animations gérées dans home-gsap.js) ───────────────
function animateTextByWords(selector = "[data-animate-text]", options = {}) {
  const {
    animateOnScroll = true,
    delay = 0,
    duration = 2,
    stagger = 0.03,
    scrollTriggerStart = "top 80%",
    scope = document,
  } = options;

  scope.querySelectorAll(selector).forEach((element) => {
    if (element.hasAttribute("data-text-animated")) return;
    element.setAttribute("data-text-animated", "true");

    const wordSpans = element.textContent.split(/(\s+)/).map((word) => {
      if (word.trim() === "") { element.appendChild(document.createTextNode(word)); return null; }
      const wrapper = document.createElement("span");
      wrapper.style.cssText = "display:inline-block;overflow:hidden;vertical-align:bottom";
      const span = document.createElement("span");
      span.textContent = word; span.style.display = "inline-block";
      wrapper.appendChild(span); element.appendChild(wrapper);
      return span;
    }).filter(Boolean);

    gsap.set(wordSpans, { y: "100%" });
    const animProps = { y: "0%", duration, stagger, ease: "power4.out", delay };
    if (animateOnScroll) {
      gsap.to(wordSpans, { ...animProps, scrollTrigger: { trigger: element, start: scrollTriggerStart, once: true } });
    } else {
      gsap.to(wordSpans, animProps);
    }
  });
}

// ── Conversation slider (GSAP) ────────────────────────────────
function initConversationSlider() {
  const container = document.querySelector(".container-conversation-slider");
  if (!container) return;

  const groups = [...document.querySelectorAll(".copy-group")];
  const NUM_GROUPS = groups.length;
  const GROUP_SEG = 1 / NUM_GROUPS;
  const STAGGER_RATIO = 0.2;
  const CROSSFADE_THRESHOLDS = [0.6, 0.73, 0.86];
  const pendingDelays = new Map();

  function prepareWords(block) {
    const p = block.querySelector("p");
    if (!p || p.dataset.wordsReady) return;
    p.dataset.wordsReady = "true";
    const words = p.textContent.split(/(\s+)/);
    p.innerHTML = "";
    words.forEach((word) => {
      if (word.trim() === "") { p.appendChild(document.createTextNode(word)); return; }
      const wrapper = document.createElement("span");
      wrapper.style.cssText = "display:inline-block;overflow:hidden;vertical-align:bottom";
      const span = document.createElement("span");
      span.textContent = word; span.style.display = "inline-block";
      wrapper.appendChild(span); p.appendChild(wrapper);
    });
    gsap.set(p.querySelectorAll("span > span"), { y: "100%" });
  }

  function animateWords(block) {
    const spans = block.querySelectorAll("p span > span");
    if (!spans.length) return;
    gsap.killTweensOf(spans);
    gsap.fromTo(spans, { y: "100%" }, { y: "0%", duration: 1.2, stagger: 0.04, ease: "power4.out" });
  }

  function animateWordsOut(block) {
    const spans = block.querySelectorAll("p span > span");
    if (!spans.length) return;
    gsap.killTweensOf(spans);
    gsap.to(spans, { y: "100%", duration: 0.8, stagger: 0.03, ease: "power4.in" });
  }

  function killPendingDelay(block) {
    if (pendingDelays.has(block)) { pendingDelays.get(block).kill(); pendingDelays.delete(block); }
  }

  function resetBlock(block) {
    killPendingDelay(block);
    const spans = block.querySelectorAll("p span > span");
    gsap.killTweensOf(spans);
    gsap.set(block, { autoAlpha: 0 });
    gsap.set(spans, { y: "100%" });
  }

  const blockVisible = new WeakMap();
  const blockCrossed = new WeakMap();
  const igFaded = new WeakMap();
  const groupXFired = new Map();
  const imageGroupes = [...document.querySelectorAll(".image-groupe")];

  imageGroupes.forEach((ig, i) => {
    if (i === 0) { gsap.set(ig, { autoAlpha: 1, display: "flex" }); igFaded.set(ig, true); }
    else { gsap.set(ig, { autoAlpha: 0, display: "none" }); igFaded.set(ig, false); }
  });

  groups.forEach((group) => {
    group.querySelectorAll(".copy-block").forEach((block) => {
      prepareWords(block);
      blockVisible.set(block, false);
      blockCrossed.set(block, false);
    });
    gsap.set(group.querySelectorAll(".copy-block"), { autoAlpha: 0 });
    groupXFired.set(group, [false, false, false]);
  });

  ScrollTrigger.create({
    trigger: container,
    start: "top top",
    end: "bottom bottom",
    onUpdate(self) {
      const p = self.progress;

      groups.forEach((group, g) => {
        const groupStart = g * GROUP_SEG;
        const groupP = (p - groupStart) / GROUP_SEG;
        const blocks = [...group.querySelectorAll(".copy-block")];
        const isFirst = g === 0;
        const isLast = g === NUM_GROUPS - 1;
        const isActive = (isFirst ? groupP >= 0 : groupP > 0) && (isLast ? true : groupP < 1);
        const exitP = !isLast && groupP > 0.6 ? (groupP - 0.6) / 0.4 : 0;
        const ig = imageGroupes[g];

        if (ig) {
          if (!isActive) {
            gsap.killTweensOf(ig);
            gsap.set(ig, { autoAlpha: 0, display: "none" });
            igFaded.set(ig, false);
          } else {
            if (!igFaded.get(ig)) {
              igFaded.set(ig, true);
              gsap.set(ig, { display: "flex", autoAlpha: 1, x: 0 });
              const igChildren = ig.querySelectorAll(".ig-placeholder, img");
              gsap.set(igChildren, { autoAlpha: 0 });
              gsap.to(igChildren, { autoAlpha: 1, duration: 1.5, ease: "power2.out", stagger: 0.4 });
            }
            gsap.set(ig, { x: `${-exitP * 110}vw` });
          }
        }

        if (!isActive) {
          blocks.forEach((block) => { resetBlock(block); blockVisible.set(block, false); blockCrossed.set(block, false); });
          groupXFired.set(group, [false, false, false]);
          return;
        }

        blocks.forEach((block, b) => {
          if (blockCrossed.get(block)) return;
          const blockStart = b * STAGGER_RATIO;
          const localP = (groupP - blockStart) / STAGGER_RATIO;
          const blockOpacity = localP >= 1 ? 1 : localP > 0 ? localP : 0;
          const wasVisible = blockVisible.get(block);
          const isNowVisible = blockOpacity > 0;
          if (!wasVisible && isNowVisible) {
            killPendingDelay(block);
            localP >= 1 ? gsap.set(block.querySelectorAll("p span > span"), { y: "0%" }) : animateWords(block);
          } else if (wasVisible && !isNowVisible) {
            gsap.set(block.querySelectorAll("p span > span"), { y: "100%" });
          }
          blockVisible.set(block, isNowVisible);
          gsap.set(block, { autoAlpha: blockOpacity });
        });

        if (!isLast) {
          const nextGroup = groups[g + 1];
          const nextBlocks = [...nextGroup.querySelectorAll(".copy-block")];
          const fired = groupXFired.get(group);
          CROSSFADE_THRESHOLDS.forEach((threshold, b) => {
            if (groupP >= threshold && !fired[b]) {
              fired[b] = true;
              if (blocks[b]) animateWordsOut(blocks[b]);
              if (nextBlocks[b]) {
                killPendingDelay(nextBlocks[b]);
                gsap.set(nextBlocks[b], { autoAlpha: 1 });
                animateWords(nextBlocks[b]);
                blockVisible.set(nextBlocks[b], true);
                blockCrossed.set(nextBlocks[b], true);
              }
            } else if (groupP < threshold && fired[b]) {
              fired[b] = false;
              if (nextBlocks[b]) { resetBlock(nextBlocks[b]); blockVisible.set(nextBlocks[b], false); blockCrossed.set(nextBlocks[b], false); }
              if (blocks[b]) gsap.set(blocks[b].querySelectorAll("p span > span"), { y: "0%" });
            }
          });
        }
      });
    },
  });
}

// ── Init GSAP animations ──────────────────────────────────────
if (document.querySelector(".container-conversation-slider")) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      animateTextByWords("[data-animate-text]", { animateOnScroll: true, delay: 0.2, scrollTriggerStart: "top 95%" });
      initConversationSlider();
    });
  } else {
    animateTextByWords("[data-animate-text]", { animateOnScroll: true, delay: 0.2, scrollTriggerStart: "top 95%" });
    initConversationSlider();
  }
}

// ── Shared cross-grid builder ────────────────────────────────
function buildCrossGrid(container, heightFn) {
  container.querySelectorAll(".cross").forEach((el) => el.remove());
  const vw    = window.innerWidth;
  const pad   = Math.max(20, Math.min(vw * 0.04, 40));
  const cols  = vw <= 768 ? 3 : 6;
  const cellW = (vw - pad * 2) / cols;
  const cellH = cellW * (3 / 4);
  const rows  = Math.ceil(heightFn() / cellH) + 1;
  for (let r = 0; r <= rows; r++) {
    for (let c = 0; c <= cols; c++) {
      const cross = document.createElement("div");
      cross.className = "cross";
      cross.style.position = "absolute";
      cross.style.left = pad + c * cellW + "px";
      cross.style.top  = r * cellH + "px";
      container.appendChild(cross);
    }
  }
}

// ── Hero grid crosses ─────────────────────────────────────────
const heroGrid = document.getElementById("hero-grid");
if (heroGrid) {
  const build = () => buildCrossGrid(heroGrid, () => heroGrid.offsetHeight);
  build();
  window.addEventListener("resize", build);
}

// ── Hero video grid trail ─────────────────────────────────────
const heroVideoWrap = document.getElementById("hero-video-wrap");
const heroGridHoverEl = document.getElementById("hero-grid-hover");

if (heroVideoWrap && heroGridHoverEl) {
  const COLS = 72;
  const ROWS = 36;
  const TRAIL_LENGTH = 18;
  const TRAIL_COLOR = "255, 111, 58";

  const cellW = 100 / COLS;
  const cellH = 100 / ROWS;

  const trailCells = [];
  for (let r = 0; r < ROWS; r++) {
    for (let c = 0; c < COLS; c++) {
      const cell = document.createElement("div");
      cell.className = "cell";
      cell.style.left = `${c * cellW}%`;
      cell.style.top = `${r * cellH}%`;
      cell.style.width = `${cellW}%`;
      cell.style.height = `${cellH}%`;
      heroGridHoverEl.appendChild(cell);
      trailCells.push(cell);
    }
  }

  const cellTimers = new Map();
  const trail = [];

  function getTrailCell(col, row) {
    if (col < 0 || col >= COLS || row < 0 || row >= ROWS) return null;
    return trailCells[row * COLS + col];
  }

  function lightTrailCell(col, row, intensity) {
    const c = getTrailCell(col, row);
    if (!c) return;
    if (cellTimers.has(c)) clearTimeout(cellTimers.get(c));
    c.style.background = `rgba(${TRAIL_COLOR}, ${intensity})`;
    c.style.opacity = String(intensity);
    c.style.transform = `scale(${0.55 + intensity * 0.35})`;
    c.style.transition = "background 0.05s, transform 0.08s, opacity 0.05s";
    const timer = setTimeout(
      () => {
        c.style.transition =
          "background 0.5s ease, transform 0.5s ease, opacity 0.5s ease";
        c.style.opacity = "0";
        c.style.transform = "scale(0.6)";
        cellTimers.delete(c);
      },
      80 + (1 - intensity) * 120,
    );
    cellTimers.set(c, timer);
  }

  heroVideoWrap.addEventListener("mousemove", function (e) {
    const rect = this.getBoundingClientRect();
    const localX = e.clientX - rect.left;
    const localY = e.clientY - rect.top;
    if (localX < 0 || localY < 0 || localX > rect.width || localY > rect.height)
      return;
    const col = Math.floor((localX / rect.width) * COLS);
    const row = Math.floor((localY / rect.height) * ROWS);
    if (col >= COLS || row >= ROWS) return;

    trail.push({ col, row });
    if (trail.length > TRAIL_LENGTH) trail.shift();

    trail.forEach((pt, i) => {
      const age = i / (trail.length - 1 || 1);
      const intensity = age * age * 0.85 + 0.05;
      lightTrailCell(pt.col, pt.row, intensity);
      if (age > 0.7) {
        [
          [-1, 0],
          [1, 0],
          [0, -1],
          [0, 1],
        ].forEach(([dc, dr]) => {
          if (Math.random() < 0.25 * age)
            lightTrailCell(pt.col + dc, pt.row + dr, intensity * 0.35);
        });
      }
    });
  });

  heroVideoWrap.addEventListener("mouseleave", () => {
    trail.length = 0;
  });
}

// ── Home grid section crosses ─────────────────────────────────
const homeGridSection = document.getElementById("home-grid-section");
const homeGridPin     = document.getElementById("home-grid-pin");
const homeExpandImg   = document.getElementById("home-expand-img");

if (homeGridSection && homeGridPin) {
  const buildHome = () => buildCrossGrid(homeGridPin, () => window.innerHeight);
  buildHome();
  window.addEventListener("resize", buildHome);
}



// ── Hero parallax ────────────────────────────────────────────
if (heroVideoWrap) {
  window.addEventListener("scroll", () => {
    if (window.scrollY > window.innerHeight) return;
    heroVideoWrap.style.transform = `translateY(${window.scrollY * 0.28}px)`;
  }, { passive: true });
}

// ── Hero scroll hint ─────────────────────────────────────────
const scrollHint = document.getElementById("scroll-hint");
if (scrollHint) {
  window.addEventListener(
    "scroll",
    () => {
      if (window.scrollY > 40) scrollHint.classList.add("hidden");
      else scrollHint.classList.remove("hidden");
    },
    { passive: true },
  );
}

// ── Hover label ───────────────────────────────────────────────
const hoverLabel = document.getElementById("hover-label");

if (hoverLabel) {
  let bx = 0,
    by = 0,
    mx = 0,
    my = 0,
    rafId = null;

  document.addEventListener("mousemove", (e) => {
    mx = e.clientX;
    my = e.clientY;
    if (!rafId) rafId = requestAnimationFrame(animateLabel);
  });

  function animateLabel() {
    bx += (mx - bx) * 0.1;
    by += (my - by) * 0.1;
    hoverLabel.style.left = bx + "px";
    hoverLabel.style.top = by + "px";
    rafId = requestAnimationFrame(animateLabel);
  }
}

// ── Initial loader ────────────────────────────────────────────
function dismissLoader(beforeExit) {
  PageTransition.enter(() => {
    if (beforeExit) beforeExit();
    initialLoader.style.display = "none";
    PageTransition.exit(startReveal);
    document.documentElement.style.overflow = "";
    document.dispatchEvent(new CustomEvent("gsap-ready"));
  });
}
const initialLoader = document.getElementById("initial-loader");
if (initialLoader) {
  if (_ptWasActive) {
    initialLoader.style.display = "none";
  } else {
    document.documentElement.style.overflow = "hidden";

    // ── Pulse canvas ─────────────────────────────────────────
    const loaderCanvas = document.getElementById("loader-canvas");
    if (loaderCanvas) {
      const lCtx = loaderCanvas.getContext("2d");
      const LCOLS = 36,
        LROWS = 22,
        LGAP = 3;
      const LPULSE_SPEED = 0.018;
      const LTRAIL = 1.2;
      const LCOLOR = [49, 49, 49];
      let lW,
        lH,
        lCW,
        lCH,
        lCX,
        lCY,
        lCells = [],
        lPulses = [],
        lRaf = null;

      function lResize() {
        lW = window.innerWidth;
        lH = window.innerHeight;
        loaderCanvas.width = Math.round(lW * devicePixelRatio);
        loaderCanvas.height = Math.round(lH * devicePixelRatio);
        lCtx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
        lCW = (lW - LGAP) / LCOLS;
        lCH = (lH - LGAP) / LROWS;
        lCX = lW / 2;
        lCY = lH / 2;
        lCells = [];
        for (let r = 0; r < LROWS; r++) {
          for (let c = 0; c < LCOLS; c++) {
            const cx = c * lCW + lCW / 2 + LGAP / 2;
            const cy = r * lCH + lCH / 2 + LGAP / 2;
            lCells.push({ cx, cy, dist: Math.hypot(cx - lCX, cy - lCY) });
          }
        }
      }

      function lDraw() {
        lCtx.clearRect(0, 0, lW, lH);
        const maxDist = Math.hypot(lCX, lCY);
        const unit = Math.max(lCW, lCH);
        for (const cell of lCells) {
          let alpha = 0;
          for (const p of lPulses) {
            const diff = p.r - cell.dist;
            if (diff > 0 && diff < LTRAIL * unit) {
              const t = diff / (LTRAIL * unit);
              const a = Math.sin(t * Math.PI) * 0.82;
              if (a > alpha) alpha = a;
            }
          }
          if (alpha > 0.01) {
            const size = (lCW - LGAP) * (0.36 + alpha * 0.28);
            lCtx.globalAlpha = alpha;
            lCtx.fillStyle = `rgb(${LCOLOR[0]},${LCOLOR[1]},${LCOLOR[2]})`;
            lCtx.fillRect(cell.cx - size / 2, cell.cy - size / 2, size, size);
          }
        }
        lCtx.globalAlpha = 1;
        const maxR = maxDist + unit * LTRAIL;
        lPulses = lPulses.filter((p) => p.r < maxR);
        for (const p of lPulses) p.r += LPULSE_SPEED * maxDist;
        lRaf = requestAnimationFrame(lDraw);
      }

      lResize();
      lPulses.push({ r: 0 });
      const lInterval = setInterval(() => lPulses.push({ r: 0 }), 2200);
      lDraw();

      setTimeout(() => {
        clearInterval(lInterval);
        dismissLoader(() => cancelAnimationFrame(lRaf));
      }, 3000);
    } else {
      setTimeout(() => dismissLoader(), 3000);
    }
  }
}
